import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/bootstrap.custom.css';
import './assets/styles/index.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import HomeScreen from './screens/HomeScreen';
import ProductScreen from './screens/ProductScreen';
import CartScreen from './screens/CartScreen';
import LoginScreen from './screens/LoginScreen';
import RegisterScreen from './screens/RegisterScreen';
import ShippingScreen from './screens/ShippingScreen';
import PaymentScreen from './screens/PaymentScreen';
import PlaceOrderScreen from './screens/PlaceOrderScreen';
import OrderScreen from './screens/OrderScreen';
import ProfileScreen from './screens/ProfileScreen';
import OrderListScreen from './screens/admin/OrderListScreen';
import ProductListScreen from './screens/admin/ProductListScreen';
import ProductEditScreen from './screens/admin/ProductEditScreen';
import UserListScreen from './screens/admin/UserListScreen';
import UserEditScreen from './screens/admin/UserEditScreen';
import store from './store';
import { Provider } from 'react-redux';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import SalesForm from './screens/SaleForm';
import SupplysForm from './screens/supplyForm';
import PurchasesForm from './screens/PurchaseForm';
import HouseEditScreen from './screens/admin/HouseEditScreen'; // Import the HouseEditScreen
import HouseListScreen from './screens/admin/HouseListScreen';
import HouseScreen from './screens/HouseScreen';
import CompoundScreen from './screens/CompoundScreen';
import Apphouse from './screens/houses';
import Appcontact from './screens/contact';
import Appservices from './screens/services';
import ExpenseListScreen from './screens/admin/ExpenseListScreen';
import ExpenseEditScreen from './screens/admin/ExpenseEditScreen';
import NoteListScreen from './screens/admin/NoteListScreen';
import NoteEditScreen from './screens/admin/NoteEditScreen';
import CustomerEditScreen from './screens/admin/CustomerEditSreen';
import CustomerListScreen from './screens/admin/CustomerListScreen';
import SaleListScreen from './screens/admin/SalesListScreen';
import SaleScreen from './screens/SaleScreen';
import SupplierEditScreen from './screens/admin/SupplierEditScreen';
import SupplierListScreen from './screens/admin/SupplierListScreen';
import TransfersForm from './screens/TransferForm';
import OpeningStocksForm from './screens/OpeningStockForm';
import StocksForm from './screens/StockForm';
import ExpenseUserList from './screens/ExpenseUserList';
import ProductUserList from './screens/ProductUserList';
import CashUserList from './screens/CashUserList';
import CustomerUserList from './screens/CustomerUserList';
import SupplierUserList from './screens/SupplierUserList';
import SupplyListScreen from './screens/admin/SupplyListScreen';
import SupplyScreen from './screens/SupplyScreen';
import TransferListScreen from './screens/admin/TransferListScreen';
import TransferScreen from './screens/TransferScreen';
import StockScreen from './screens/StockScreen';
import OpeningStockScreen from './screens/OpeningStockScreen';
import StockListScreen from './screens/admin/StockListScreen';
import OpeningStockListScreen from './screens/admin/OpeningStockListScreen';
import SalesEditScreen from './screens/SalesEditScreen';
import StocksEditScreen from './screens/StockEditScreen';
import OpeningStocksEditScreen from './screens/OpeningStockEditScreen';
import TransfersEditScreen from './screens/TransferEditScreen';
import CartForm from './screens/CartForm';
import StaffSale from './screens/StaffSale';
import StaffSupply from './screens/StaffSupply';
import StaffStock from './screens/StaffStock';
import StaffOpeningStock from './screens/StaffOpeningStock';
import StaffTransfer from './screens/StaffTransfer';
import StockAnalysis from './screens/admin/StockAnalysis';
import Balance from './screens/admin/Balance';
import NetCash from './screens/admin/NetCash';
import NetCashEdit from './screens/admin/NetCashEdit';
import ExpenseScreen from './screens/ExpenseScreen';
import IncomeScreen from './screens/IncomeScreen';
import NoteScreen from './screens/NoteScreen';
import DepositScreen from './screens/DepositScreen';
import DepositEditScreen from './screens/admin/DepositEditScreen';
import DepositListScreen from './screens/admin/DepositListScreen';
import AllTotal from './screens/admin/AllTotal';
import BagScreen from './screens/BagScreen';
import BagEditScreen from './screens/admin/BagEditScreen';
import BagListScreen from './screens/admin/BagListScreen';
import StaffNote from './screens/StaffNote';
import StockReport from './screens/admin/StockReport';
import SupplysEditScreen from './screens/SupplyEditScreen';
import AdminForm from './screens/AdminForm';
import BankUserList from './screens/BankUserList';
import StaffHouseList from './screens/StaffHouseList';
import StaffHomeScreen from './screens/StaffHomeScreen';
import ProductStaffEditScreen from './screens/admin/ProductStaffEditScreen';
import ExpenseStaffEditScreen from './screens/admin/ExpenseStaffEditScreen';
import DepositStaffEditScreen from './screens/admin/DepositStaffEditScreen';
import BagStaffEditScreen from './screens/admin/BagStaffEditScreen';
import CustomerStaffEditScreen from './screens/admin/CustomerStaffEditScreen';
import SupplierStaffEditScreen from './screens/admin/SupplierStaffEditScreen';
import HouseStaffEditScreen from './screens/admin/HouseStaffEditScreen';
import AdminProfileScreen from './screens/admin/AdminProfileScreen.jsx';
import AdminUsersScreen from './screens/admin/AdminUsersScreen';
import UseStockAnalysis from  './screens/admin/useStockAnalysis.js';
import AddExpenseScreen from './screens/admin/AddExpenseScreen.jsx';
import AddIncomeScreen from './screens/admin/AddIncomeScreen.jsx';
import AddDepositScreen from './screens/admin/AddDepositScreen.jsx';
import AddStaffExpense from './screens/admin/AddStaffExpense.jsx';
import AddStaffDeposit from './screens/admin/AddStaffDeposit.jsx';
import AddStaffIncome from './screens/admin/AddStaffIncome.jsx';
import StockUniqueDates from './screens/admin/StockUniqueDates.jsx';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<App />}>
      <Route index={true} path='/' element={<CompoundScreen />} />
      <Route path='/search/:keyword' element={<CompoundScreen />} />
      <Route path='/page/:pageNumber' element={<CompoundScreen />} />
      <Route path='/page/:pageNumber' element={<HomeScreen />} />
      <Route
        path='/search/:keyword/page/:pageNumber'
        element={<CompoundScreen />}
      />
      
      <Route
        path='/house/CompoundScreen'
        element={<CompoundScreen />}
      />
      <Route
        path='/house/HomeScreen'
        element={<HomeScreen />}
      />
       <Route
        path='/houses'
        element={<Apphouse />}
      />
      <Route path='/house/:id' element={<HouseScreen />} />
      <Route path='/alltotal' element={<AllTotal />} />
      <Route
          path='/admin/house/:id/edit'
          element={<HouseEditScreen />}
        /> {/* New route for House Edit */}
        <Route
          path='/house/:id/edit'
          element={<HouseStaffEditScreen />}
        /> {/* New route for House Edit */}
      <Route path='/expense/:id' element={<ExpenseScreen />} />
      <Route path='/deposit/:id' element={<DepositScreen />} />
      <Route path='/income/:id' element={<IncomeScreen />} />
      <Route path='/note/:id' element={<NoteScreen />} />
      <Route path='/bag/:id' element={<BagScreen />} />
      <Route path='/product/:id' element={<ProductScreen />} />
      <Route path='/cart' element={<CartScreen />} />
      <Route path='/usestockanalysis' element={<UseStockAnalysis />} />
      <Route path='/staffhomescreen' element={<StaffHomeScreen />} />
      <Route path='/cartform' element={<CartForm />} />
      <Route path='/adminform' element={<AdminForm />} />
      <Route path='/staffsale' element={< StaffSale />} />
      <Route path='/stockanalysis' element={< StockAnalysis />} />
      <Route path='/stockreport' element={< StockReport />} />
      <Route path='/balance' element={< Balance />} />
      <Route path='/create/expense' element={< AddExpenseScreen />} />
      <Route path='/create/staff/expense' element={< AddStaffExpense />} />
      <Route path='/create/income' element={< AddIncomeScreen />} />
      <Route path='/create/staff/income' element={< AddStaffIncome />} />
      <Route path='/create/deposit' element={< AddDepositScreen />} />
      <Route path='/create/staff/deposit' element={< AddStaffDeposit />} />
      <Route path='/netcash' element={< NetCash />} />
      <Route path='/staffsupply' element={< StaffSupply />} />
      <Route path='/staffstock' element={< StaffStock />} />
      <Route path='/staffnote' element={< StaffNote />} />
      <Route path='/staffopeningstock' element={< StaffOpeningStock />} />
      <Route path='/stafftransfer' element={< StaffTransfer />} />
      <Route path='/customeruserlist' element={<CustomerUserList/>} />
      <Route path='/customer/:id/edit' element={<CustomerStaffEditScreen />} />
      <Route path='/supplier/:id/edit' element={<SupplierStaffEditScreen />} />
      <Route path='/supplierlist' element={<SupplierUserList />} />
      <Route path='/admin/note/:id/edit' element={< NoteEditScreen />} />
      <Route path='/admin/bag/:id/edit' element={< BagEditScreen />} />
      <Route path='/bag/:id/edit' element={< BagStaffEditScreen />} />
      <Route path='/contact' element={<Appcontact />} />
      <Route path='/services' element={<Appservices />} />
      <Route path='/login' element={<LoginScreen />} />
      <Route path='/register' element={<RegisterScreen />} />
      <Route path='/salesform' element={<SalesForm />} />
      <Route path='/supplysform' element={<SupplysForm />} />
      <Route path='/transfersform' element={<TransfersForm />} />
      <Route path='/purchasesform' element={<PurchasesForm />} />
      <Route path='/stocksform' element={<StocksForm />} />
      <Route path='/expenselist' element={<ExpenseUserList />} />
      <Route path='/productlist' element={<ProductUserList />} />
      <Route path='/cashlist' element={<CashUserList />} />
      <Route path='/stockuniquedates' element={<StockUniqueDates />} />
      <Route path='/bankuserlist' element={<BankUserList />} />
      <Route path='/staffhouselist' element={<StaffHouseList />} />
      
      <Route path='/income/:id/edit' element={<NetCashEdit />} />
      <Route path='/expense/:id/edit' element={<ExpenseStaffEditScreen />} />
      <Route path='/admin/deposit/:id/edit' element={<DepositEditScreen />} />
      <Route path='/deposit/:id/edit' element={<DepositStaffEditScreen />} />
      <Route path='/supply/:id/edit' element={<SupplysEditScreen />} />
      <Route path='/openingstocksform' element={<OpeningStocksForm />} />
      <Route path='' element={<PrivateRoute />}>
        <Route path='/shipping' element={<ShippingScreen />} />
        <Route path='/payment' element={<PaymentScreen />} />
        <Route path='/placeorder' element={<PlaceOrderScreen />} />
        <Route path='/order/:id' element={<OrderScreen />} />
        <Route path='/sale/:id' element={<SaleScreen />} />

        <Route path='/product/:id/edit' element={<ProductStaffEditScreen />} />
        <Route path='/stock/:id' element={< StockScreen/>} />
        <Route path='/openingstock/:id' element={< OpeningStockScreen />} />
        <Route path='/transfer/:id' element={<TransferScreen />} />
        <Route path='/supply/:id' element={<SupplyScreen />} />
        <Route path='/profile' element={<ProfileScreen />} />
      </Route>
      {/* Admin users */}
      <Route path='' element={<AdminRoute />}>
        <Route path='/admin/orderlist' element={<OrderListScreen />} />
        <Route path='/admin/salelist' element={<SaleListScreen />} />
        <Route path='/admin/stocklist' element={<StockListScreen />} />
        <Route path='/admin/openingstocklist' element={<OpeningStockListScreen />} />
        <Route path='/admin/transferlist' element={<TransferListScreen />} />
        <Route path='/admin/productlist' element={<ProductListScreen />} />
        <Route path='/admin/expenselist' element={<ExpenseListScreen />} />
        <Route path='/admin/depositlist' element={<DepositListScreen />} />
        <Route path='/admin/notelist' element={<NoteListScreen />} />
        <Route path='/admin/baglist' element={<BagListScreen />} />
        <Route
          path='/productlist/:pageNumber'
          element={<ProductListScreen />}
        />

        <Route
          path='/admin/salelist/:pageNumber'
          element={<SaleListScreen />}
        />
        <Route
        path='/house/HomeScreen/:pageNumber'
        element={<HomeScreen />}
        />
        <Route
          path='/staffhouselist/:pageNumber'
          element={<StaffHouseList />}
        />
        <Route
          path='/admin/transferlist/:pageNumber'
          element={<TransferListScreen />}
        />
        <Route
          path='/admin/supplylist/:pageNumber'
          element={<SupplyListScreen />}
        />
        <Route
          path='/admin/stocklist/:pageNumber'
          element={<StockListScreen />}
        />
        <Route
          path='/admin/customerlist/:pageNumber'
          element={<CustomerListScreen />}
        />
        <Route
          path='/admin/supplierlist/:pageNumber'
          element={<SupplierListScreen />}
        />
        <Route
          path='/admin/openingstocklist/:pageNumber'
          element={<OpeningStockListScreen />}
        />
        <Route
          path='/admin/expenselist/:pageNumber'
          element={<ExpenseListScreen />}
        />
        <Route
          path='/admin/depositlist/:pageNumber'
          element={<DepositListScreen />}
        />
        <Route
          path='/netcash/:pageNumber'
          element={<NetCash />}
        />
        <Route
          path='/admin/notelist/:pageNumber'
          element={<NoteListScreen />}
        />
        <Route
          path='/admin/houselist/:pageNumber'
          element={<HouseListScreen />}
        />
        <Route
          path='/admin/baglist/:pageNumber'
          element={<BagListScreen />}
        />
        <Route path='/admin/houselist' element={<HouseListScreen />} /> {/* New route for House List */}
        <Route path='/admin/userlist' element={<UserListScreen />} />
        <Route path='/admin/product/:id/edit' element={<ProductEditScreen />} />
        <Route path='/admin/sale/:id/edit' element={<SalesEditScreen />} />
        <Route path='/admin/transfer/:id/edit' element={<TransfersEditScreen />} />
        <Route path='/admin/openingStock/:id/edit' element={<OpeningStocksEditScreen />} />
        <Route path='/admin/stock/:id/edit' element={<StocksEditScreen />} />
        <Route path='/admin/expense/:id/edit' element={<ExpenseEditScreen />} />
        <Route path='/admin/customer/:id/edit' element={<CustomerEditScreen />} />
        
        <Route path='/admin/supplier/:id/edit' element={<SupplierEditScreen />} />
        <Route path='/admin/customerlist' element={<CustomerListScreen />} />
        
        <Route path='/admin/supplierlist' element={<SupplierListScreen />} />
        <Route path='/admin/supplylist' element={<SupplyListScreen />} />
        <Route path='/admin/adminuserprofile' element={<AdminProfileScreen />} />
        <Route path='/admin/adminuserscreen' element={<AdminUsersScreen />} />
        <Route path='/admin/user/:id/edit' element={<UserEditScreen />} />
      </Route>
    </Route>
  ),
  

);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <PayPalScriptProvider deferLoading={true}>
          <RouterProvider router={router} />
        </PayPalScriptProvider>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
